<div class="rounded home-member-card">
  <div class="member-card-details d-flex">
    <div class="member-details d-flex flex-column" *ngIf="memberDetails$ | async as member">
      <label class="mt-0 mb-2 text-white font-size-14">{{ member?.FirstName + ' ' + member?.Surname }}</label>
      <span class="font-size-10 text-white" *ngIf="memberCard$ | async as memberCard">
        {{ memberCard?.ProductCode | accountMembership | translate }}
        &nbsp;-&nbsp;
        {{ memberCard?.MemberId }}
      </span>
    </div>
    <div>
      <img alt="logo-member-card" class="logo-member-card" [src]="'logos/logowhite.png' | contentAssetImage" draggable="false" />
    </div>
  </div>
</div>
